import _ from "lodash";

export function keyToQuery (key) {
    return `existing: ${key.namespace}."${key.name}"`
}
export function keyToQuery_ (key) {
    return `existing: ${key.namespace}.${key.name}`
}

export function queryToName (q) {
    return q.replace(/existing: [a-zA-Z0-9]+\./, "").replaceAll(/\"/g, "")
}

export function parens(s) {
    return `(${s})`
}
export function names(cs) {
    return _.map(cs, c => JSON.parse(JSON.stringify(c.key)))
}
